<template lang="html">
  <booking-tabs
    :calendar-id="operator.id"
    :calendar-title="`Calendar for ${operator.title}`"
  >
    <template v-slot:rules="slotProps">
      <booking-rules v-bind="slotProps" />
    </template>
    <template v-slot:resources="slotProps">
      <booking-resources v-bind="slotProps" />
    </template>
    <template v-slot:events="slotProps">
      <booking-events v-bind="slotProps" />
    </template>
    <template v-slot:layoutview="slotProps">
      <booking-layoutview v-bind="slotProps" />
    </template>
    <template v-slot:layouts="slotProps">
      <booking-layouts v-bind="slotProps" />
    </template>
  </booking-tabs>
</template>

<script>
import {BookingTabs} from 'dync-booking'
import BookingEvents from './BookingEvents.vue'
import BookingRules from './BookingRules.vue';
import BookingResources from './BookingResources.vue';
import BookingLayoutview from './BookingLayoutview.vue';
import BookingLayouts from './BookingLayouts.vue';

export default {
  props: ['operator'],
  data() {
    return {
    };
  },
  components: {
    BookingTabs,
    BookingRules,
    BookingResources,
    BookingEvents,
    BookingLayoutview,
    BookingLayouts
  }
}
</script>

<style lang="css" scoped>
</style>
